import { HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';


@Injectable({
    providedIn: 'root',
})
export class PdfService {

  constructor(private http: HttpClient) { }
    
  getPDF(pdfSrc:string){
    return new Promise<Blob>((resolve, reject) => {
      this.http.get(pdfSrc, {responseType: 'blob'}).subscribe(data => {
        resolve(data);
      }, (err) => {
        reject(err);
    });
    })
  } 
}

